import { MERCHANT_CODE } from "./tenant";
import { backendBaseUrl, configuredBackendBase } from "./backendUrl";

export const backendAssetBase = () => backendBaseUrl();
const merchantCode = value => typeof value === "string" && /^[a-z0-9](?:[a-z0-9-]{0,38}[a-z0-9])?$/.test(value) ? value : "";

/** Public images cannot attach the API client's tenant header or bearer token. */
export function assetUrl(value, options = {}) {
  const { merchantCode: requestedMerchant = MERCHANT_CODE, backendUrl = backendAssetBase() } = options;
  if (typeof value !== "string" || !value.trim()) return "";
  const source = value.trim();
  if (/^(?:javascript|file|vbscript):/i.test(source) || /^data:(?!image\/)/i.test(source)) return "";
  const base = String(backendUrl || "").replace(/\/+$/, "");
  let path = source;
  if (base && source.startsWith(`${base}/api/`)) path = source.slice(base.length);
  // Application-owned URLs saved with the platform origin must also retain the
  // custom domain on reads. Explicit caller overrides keep their original base.
  const configuredBase = configuredBackendBase();
  if (!Object.prototype.hasOwnProperty.call(options, "backendUrl") && !base && configuredBase
    && source.startsWith(`${configuredBase}/api/`)) path = source.slice(configuredBase.length);
  if (!path.startsWith("/api/")) return source;
  const code = merchantCode(requestedMerchant);
  const legacy = path.match(/^\/api\/public\/website\/asset\/([^/?#]+)([?#].*)?$/);
  if (legacy && code) path = `/api/public/website/asset/${encodeURIComponent(code)}/${legacy[1]}${legacy[2] || ""}`;
  return `${base}${path}`;
}
